<template>
    <div style="overflow: hidden;position: relative;padding:4px;">
        <modal-r :show="showEdit" v-if="showEdit" @onclose="showEdit = false">
            <div style="width:100%;height:100%;margin:0 auto;overflow-y:auto;border:2px solid #ddd;background:white;">
                <div style="text-align:left;">
                    <div class="col-xs-12">
                        <h3>{{ lang.postProps.edit }}: <span v-if="catRef !== null">{{ catRef.name }}</span></h3>
                    </div>
                    <div class="col-xs-12 agx-col-msg">
                        <input class="form-control" style="width:100%;" type="text" name="title"
                            v-model="editingCat.name" />
                    </div>
                </div>
                <br />
                <div class="col-xs-12" style="text-align:right;">
                    <input type="button" value="Update" class="btn btn-primary" @click="updateCatClick" />
                </div>
            </div>
        </modal-r>
        <div class="col-xs-12 col-md-6"
            style="margin-top:4px;padding-top:2px;padding-bottom: 20px;outline: none;border-color: #9ecaed;box-shadow: 0 0 10px #9ecaed;">
            <div class="col-xs-12" style="max-height:300px;overflow-y:auto;">
                <!-- <div class="col-xs-12">
                    <span  v-if="!showParent"  @click="showParent = true" class="btn btn-default" style="float:left;"> back </span> 
                </div> -->
                <div class="col-xs-12" style="margin-top:4px;" v-if="cpdAllowNewProp">
                    <input type="text" v-model="newPropName" class="form-control" placeholder="Name" />
                    <div style="text-align:right;">
                        <!-- <span  v-if="!showParent"  @click="showParent = true" class="btn btn-default" style="float:left;"> back </span>  -->
                        <input type="button" class="btn btn-primary" @click="addParentProp" v-if="showParent"
                            :value="lang.postProps.newProp" />
                        <input type="button" class="btn btn-primary" @click="addChildProp" v-else
                            :value="' + ' + optionGroup.parent.name" />
                    </div>
                </div>
                <div v-if="showParent" class="col-xs-12">
                    <div
                        style="position:sticky;top:0px;background: white;text-align: left;font-size:1.2em;color: blue;cursor: pointer;">
                        <!-- <span>Parent</span> -->
                        <hr />
                        <span>{{ lang.postProps.properties }}</span>
                    </div>

                    <div v-for="item in propOptions" style="display:flex;flex-direction: row;">
                        <span @click="parentClick(item)" class="btn btn-default"
                            :style="{ fontWeight: optionGroup === item ? 'bolder' : '' }" style="width:100%;">
                            {{ item.parent.name }}
                        </span>
                        <span class="btn btn-default" @click="editCat(item.parent)"
                            v-if="cpdAllowNewProp">{{ lang.postProps.edit }}</span>
                    </div>
                </div>
                <div v-if="!showParent" class="col-xs-12">
                    <div
                        style="position:sticky;top:0px;background: white;text-align: left;font-size:1.2em;color: blue;cursor: pointer;">
                        <!-- | <span>Child</span> -->
                        <hr />
                        <div style="text-align: left;">
                            <span v-if="!showParent" @click="showParent = true" class="glyphicon glyphicon-arrow-left"
                                style=""></span> | 
                            <span>{{ optionGroup.parent.name }}</span>
                        </div>
                    </div>

                    <template v-if="optionGroup">
                        <div v-for="c in optionGroup.childs"
                            style="display:flex;flex-direction: row;font-weight:bolder;">
                            <span @click="addPropToPost(c, optionGroup.parent)" style="width:100%;"
                                class="btn btn-default">
                                {{ c.name }}
                            </span>
                            <span class="btn btn-default" @click="editCat(c)">{{ lang.postProps.edit }}</span>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <div class="col-xs-12 col-md-6">
            <div v-for="item in dataList">
                <div style="width:100%;" v-if="item.childs.length > 0">
                    <div style="font-weight:bolder;">{{ item.parent.name }}</div>
                    <div>
                        <span v-for="cItem in item.childs" class="btn btn-default" style="margin:1px;">
                            {{ cItem.name }} <span class="btn btn-warning"
                                @click="removePostProp(item.parent, cItem)">X</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xs-12" style="text-align:center;margin-top:10px;">
            <span class="form-control btn btn-primary" @click="setPostProps">{{ lang.postProps.updateProperties }}</span>
        </div>
    </div>
</template>
<script>
import imageList from './imageList.vue';
import modalX from '../components/base/ModalX1.vue';
import modalR from '../components/base/ModalR1.vue';

export default {
    components: {
        imageList: imageList,
        modalX: modalX,
        modalR: modalR
    },
    computed: {
        lang: function () {
            return this.$store.getters.lang;
        },
        dashProfile: function () {
            return this.$store.getters.dashProfile;
        },
        cpdAllowNewProp: function () {
            return this.dashProfile && (!this.dashProfile.hasTeam || this.dashProfile.isAdmin);
        }
    },
    props: {
        itemProps: { type: Array, default: null },
        apiClient: null
    },
    data: function () {
        return {
            dataList: [],
            propOptions: [],
            optionGroup: null,
            newPropName: null,
            showParent: true,
            editingCat: null,
            showEdit: false,
            catRef: null
        };
    },
    methods: {
        updateCatClick() {
            this.updatePropCat(this.editingCat);
        },
        editCat(cat) {
            console.log('editing cat', cat);
            this.catRef = cat;
            this.editingCat = { ...cat };
            this.showEdit = true;
        },
        parentClick(parent) {
            this.optionGroup = parent;
            this.showParent = false;
        },
        removePostProp(propObj, propVal) {
            var matched = this.getMatchedPropInternal(propObj, this.dataList);
            if (matched) {
                var index = matched.childs.indexOf(propVal);
                matched.childs.splice(index, 1);
            }
        },
        getGrouped(_dataList) {
            //var _dataList = this.dataList;
            var arrList = [];
            for (var i = 0; i < _dataList.length; i++) {
                var item = _dataList[i];
                var newArr = [];
                for (var j = 0; j < item.childs.length; j++) {
                    var expanded = { parent: item.parent, child: item.childs[j] };
                    newArr.push(expanded);
                }
                if (newArr.length > 0) {
                    arrList.push(newArr);
                }
            }
            console.log("arrList", arrList);
            var ret = arrList.shift();
            if (arrList.length === 0) {
                var mRet = [];
                if (!ret) return [];
                for (var i = 0; i < ret.length; i++) {
                    mRet.push([ret[i]]);
                }
                console.log("getGrouped", mRet);
                return mRet;
            }

            while (arrList.length > 0) {
                var next = arrList.shift();
                ret = joinArr(ret, next);
            }

            function joinArr(arr1, arr2) {
                if (arr2 && arr2.length > 0) {
                    var ret = [];
                    for (var i = 0; i < arr1.length; i++) {
                        var arr1Item = arr1[i];
                        for (var k = 0; k < arr2.length; k++) {
                            var arr2Item = arr2[k];
                            var isArrayItem = arr1Item instanceof Array;
                            if (isArrayItem) {
                                var aCopy = arr1Item.slice();
                                aCopy.push(arr2Item);
                                ret.push(aCopy);
                            } else {
                                ret.push([arr1Item, arr2Item]);
                            }
                        }
                    }
                    return ret;
                }
                return arr1;
            }

            return ret;
        },
        updatePropCat(cat) {
            this.apiClient.updatePropCatPrms(cat).done((data) => {
                console.log("cat updated", data);
                this.showEdit = false;
                if (data.ok === true) {
                    this.catRef.name = data.value.name;
                }
            });
        },
        addParentProp() {
            this.apiClient.addParentPropCatPrms(this.newPropName).done((data) => {
                console.log("addParentProp", data);
                if (data.ok === true) {
                    var datum = { parent: data.value, childs: [] };
                    this.propOptions.unshift(datum);
                    this.optionGroup = datum;
                } else {
                    alert('error');
                }
            });
        },
        addChildProp() {
            if (this.optionGroup === null) return;
            this.apiClient.addPropCatPrms(this.newPropName, this.optionGroup.parent.catId).then((data) => {
                console.log('addChildProp', data);
                if (data.ok === true) {
                    this.addToOptions(this.optionGroup.parent, data.value);
                } else {
                    alert('error');
                }
            });
        },
        setPostProps() {
            var grouped = this.getGrouped(this.dataList);
            this.$emit('update', grouped);
        },
        addPropToPost(child, parent) {
            this.add(parent, child);
        },
        loadOptions() {
            console.log('postProps', this.apiClient);
            this.apiClient.getPropertiesPrms().done((data) => {
                console.log('property options', data);
                this.propOptions = data;
                this.optionGroup = data[0];
            });
        },
        loadProps() {
            this.apiClient.getPostPropPrms().then((data) => {
                var props = data;
                console.log("loadProps", props);
                if (props !== null && props.length > 0) {
                    props.forEach((item) => {
                        var catPairs = item.catPairs;
                        if (catPairs !== null && catPairs.length > 0) {
                            catPairs.forEach((t) => {
                                console.log('catPairs', t);
                                this.add(t.parent, t.child);
                            });
                        }
                    });
                }
            });
        },
        addToOptions(prop, propVal) {
            if (this.checkExist(prop, propVal, this.propOptions)) return;
            var _currentPropRef = this.setParentProp(prop, this.propOptions);
            _currentPropRef.childs.push(propVal);
        },
        add(prop, propVal) {
            if (this.checkExist(prop, propVal, this.dataList)) return;
            var _currentPropRef = this.setParentProp(prop, this.dataList);
            _currentPropRef.childs.push(propVal);
        },
        checkExist(propObj, valObj, list) {
            //if (_allowDuplicate) return false;
            var prop = this.getMatchedPropInternal(propObj, list);
            if (!prop) return false;
            var propVal = this.getMatched(valObj, prop.childs, this.propValComparer);
            if (propVal) return true;
            return false;
        },
        getMatched(target, list, comparer) {
            var matched = null;
            list.forEach((item) => {
                if (comparer) {
                    var ret = comparer(target, item);
                    if (ret === true) {
                        matched = item;
                        return;
                    }
                }
            });
            return matched;
        },
        setParentProp(propObj, list) {
            var matched = this.getMatchedPropInternal(propObj, list);
            if (matched) return matched;
            var datum = { parent: propObj, childs: [] };
            //this.dataList.push(datum);
            list.push(datum);
            return datum;
        },
        getMatchedPropInternal(propObj, propArr) {
            var matched = null;
            propArr.forEach((item) => {
                var _propComparer = this.propComparer;
                if (_propComparer) {
                    var ret = _propComparer(propObj, item.parent);
                    if (ret === true) {
                        matched = item;
                        return;
                    }
                }
            });
            return matched;
        },
        propComparer(item0, item1) {
            return item0.catId === item1.catId;
        },
        propValComparer(item0, item1) {
            return item0.catId === item1.catId;
        }
    },
    created: function () {

    },
    mounted: function () {
        console.log('mounted');
        //this.loadProps(this.itemProps);
        this.loadProps();
        this.loadOptions();
    },
    destroyed: function () {

    }
}
</script>